import { Text } from '@fundamentals'

export const RegisterItemText: React.FC<{}> = ({ children }) => {
  return (
    <Text align='left' fontSize={14}>
      {children}
    </Text>
  )
}
